
            const data = {"name":"icon-return-item","data":{"viewBox":"0 0 32 32","data":"<path pid=\"0\" d=\"M10.854 15.146l.057.07a.5.5 0 01-.695.695l-.07-.057-5-5-.057-.07a.5.5 0 010-.568l.057-.07 5-5a.5.5 0 01.765.638l-.057.07L6.706 10H19.5a8.5 8.5 0 01.255 16.996L19.5 27H7.078a.5.5 0 01-.09-.992l.09-.008H19.5a7.5 7.5 0 00.243-14.996L19.5 11H6.707l4.147 4.146z\" _fill=\"#000\" fill-rule=\"nonzero\"/>"}}
        
                module.exports = data
                